var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2672",
    "data-name": "Group 2672",
    transform: "translate(-9 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2672-2",
    "data-name": "Group 2672",
    transform: "translate(9 19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M9.988,19H12.6a1,1,0,0,1,.633.224l.856.7h0a.2.2,0,0,0,.127.045h8.032a.978.978,0,0,1,.988.968v1.742a.2.2,0,0,0,.2.194h.791a.773.773,0,0,1,.781.764.75.75,0,0,1-.021.177l-1.567,6.444a.984.984,0,0,1-.961.744H9.988A.978.978,0,0,1,9,30.032V19.968H9A.978.978,0,0,1,9.988,19ZM23.9,24.077h0a.189.189,0,0,0,.005-.045.2.2,0,0,0-.2-.194H12.494a.394.394,0,0,0-.382.286L10.55,29.788a.19.19,0,0,0-.007.051.2.2,0,0,0,.2.194H22.294a.2.2,0,0,0,.192-.149h0ZM10.186,19.968h0a.2.2,0,0,0-.2.194h0v7.5a.078.078,0,0,0,.058.075.079.079,0,0,0,.1-.055h0l1.13-4.094a.985.985,0,0,1,.954-.715h9.818a.2.2,0,0,0,.2-.194V21.129a.2.2,0,0,0-.2-.194H14.139a1,1,0,0,1-.633-.224l-.856-.7a.2.2,0,0,0-.127-.045H10.186Z",
    transform: "translate(-9 -19)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOut);
export default __webpack_public_path__ + "static/media/folder-out.e04a1b8b.svg";
export { ForwardRef as ReactComponent };